// @flow
import React, { Children } from 'react'
import { Route } from 'react-router-dom'

import { useUser } from '../../data/UserContext'
import { HomeRedirect } from '../HomeRedirect'
import { grantAccess } from '../../utils/grantAccess'

export const PrivateRoute = ({
  roles, canUseInternshipPermission, isInternshipDirector, children
}) => {
  const { user } = useUser()
  if (!grantAccess({
    user,
    roles,
    canUseInternshipPermission,
    isInternshipDirector,
  })) {
    return <HomeRedirect />
  }

  return (children)
}
